import { ComingSoonDialogComponent } from './coming-soon-dialog.component.ts';
import { DialogService } from 'primeng/dynamicdialog';

export const ComingSoonDialog = (
  featureId: string,
  text: string,
): Parameters<typeof DialogService.prototype.open> => [
  ComingSoonDialogComponent,
  {
    header: 'Coming Soon',
    data: { featureId, text: text.replace(/[\r\n]/g, '<br/>') },
    modal: true,
    closable: true,
    closeOnEscape: true,
  },
];
